module.exports = __webpack_public_path__ + "static/media/SENSE.ede5e127.png";